// Translations for FR and EN
export const translations = {
  fr: {
    // Header
    nav: {
      services: "Services",
      fleet: "Notre Flotte",
      book: "Réserver",
      contact: "Contact"
    },
    
    // Hero
    hero: {
      label: "Transport VTC Premium",
      title: "Voyagez avec",
      titleHighlight: "Excellence",
      subtitle: "Service de chauffeur privé Tesla sur la Côte d'Azur. Luxe, confort et ponctualité garantis."
    },
    
    // Booking Form
    booking: {
      tripMode: "Trajet A → B",
      hourlyMode: "Mise à disposition",
      pickupLabel: "Départ",
      pickupPlaceholder: "Adresse de départ",
      dropoffLabel: "Arrivée",
      dropoffPlaceholder: "Adresse d'arrivée",
      dateLabel: "Date",
      timeLabel: "Heure",
      vehicleLabel: "Véhicule",
      hoursLabel: "Nombre d'heures",
      nameLabel: "Nom complet",
      namePlaceholder: "Votre nom",
      phoneLabel: "Téléphone",
      phonePlaceholder: "+33 6 XX XX XX XX",
      paymentLabel: "Paiement",
      cardPayment: "Carte bancaire (Acompte 50%)",
      cashPayment: "Espèces au chauffeur",
      calculateBtn: "Calculer le prix",
      bookBtn: "Réserver maintenant",
      calculating: "Calcul en cours...",
      processing: "Traitement...",
      selectDate: "Sélectionner une date"
    },
    
    // Price
    price: {
      basePrice: "Prix de base",
      nightSurcharge: "Supplément nuit (22h-6h)",
      total: "Total",
      deposit: "Acompte à payer",
      perKm: "€/km",
      minimum: "Minimum 25€",
      hourlyRate: "80€/heure",
      distance: "Distance",
      duration: "Durée",
      hours: "heures",
      minutes: "min"
    },
    
    // Vehicles
    vehicles: {
      modelY: {
        name: "Tesla Model Y",
        description: "SUV premium, 4 passagers"
      },
      model3: {
        name: "Tesla Model 3",
        description: "Berline élégante, 3 passagers"
      }
    },
    
    // Services
    services: {
      title: "Nos Services",
      airport: {
        title: "Transferts Aéroport",
        description: "Nice, Cannes, Monaco - Accueil personnalisé avec panneau nominatif"
      },
      events: {
        title: "Événements & Soirées",
        description: "Festival de Cannes, Galas, Événements privés sur la Côte d'Azur"
      },
      business: {
        title: "Déplacements Professionnels",
        description: "Ponctualité et discrétion pour vos rendez-vous d'affaires"
      }
    },
    
    // Footer
    footer: {
      description: "Service de chauffeur privé premium sur la Côte d'Azur. Véhicules Tesla 100% électriques.",
      contact: "Contact",
      hours: "Disponible 24h/24, 7j/7",
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
      rights: "Tous droits réservés"
    },
    
    // Success/Error pages
    success: {
      title: "Réservation Confirmée",
      message: "Merci ! Votre réservation a été enregistrée.",
      whatsappMessage: "Contactez-nous sur WhatsApp pour toute question",
      backHome: "Retour à l'accueil"
    },
    cancel: {
      title: "Paiement Annulé",
      message: "Le paiement a été annulé. Vous pouvez réessayer.",
      retry: "Réessayer"
    }
  },
  
  en: {
    // Header
    nav: {
      services: "Services",
      fleet: "Our Fleet",
      book: "Book Now",
      contact: "Contact"
    },
    
    // Hero
    hero: {
      label: "Premium VTC Transport",
      title: "Travel with",
      titleHighlight: "Excellence",
      subtitle: "Private Tesla chauffeur service on the French Riviera. Luxury, comfort and punctuality guaranteed."
    },
    
    // Booking Form
    booking: {
      tripMode: "Trip A → B",
      hourlyMode: "Hourly Rental",
      pickupLabel: "Pickup",
      pickupPlaceholder: "Pickup address",
      dropoffLabel: "Drop-off",
      dropoffPlaceholder: "Drop-off address",
      dateLabel: "Date",
      timeLabel: "Time",
      vehicleLabel: "Vehicle",
      hoursLabel: "Number of hours",
      nameLabel: "Full Name",
      namePlaceholder: "Your name",
      phoneLabel: "Phone",
      phonePlaceholder: "+33 6 XX XX XX XX",
      paymentLabel: "Payment",
      cardPayment: "Credit Card (50% Deposit)",
      cashPayment: "Cash to driver",
      calculateBtn: "Calculate Price",
      bookBtn: "Book Now",
      calculating: "Calculating...",
      processing: "Processing...",
      selectDate: "Select a date"
    },
    
    // Price
    price: {
      basePrice: "Base Price",
      nightSurcharge: "Night Surcharge (10pm-6am)",
      total: "Total",
      deposit: "Deposit to pay",
      perKm: "€/km",
      minimum: "Minimum €25",
      hourlyRate: "€80/hour",
      distance: "Distance",
      duration: "Duration",
      hours: "hours",
      minutes: "min"
    },
    
    // Vehicles
    vehicles: {
      modelY: {
        name: "Tesla Model Y",
        description: "Premium SUV, 4 passengers"
      },
      model3: {
        name: "Tesla Model 3",
        description: "Elegant sedan, 3 passengers"
      }
    },
    
    // Services
    services: {
      title: "Our Services",
      airport: {
        title: "Airport Transfers",
        description: "Nice, Cannes, Monaco - Personalized welcome with name sign"
      },
      events: {
        title: "Events & Parties",
        description: "Cannes Film Festival, Galas, Private events on the French Riviera"
      },
      business: {
        title: "Business Travel",
        description: "Punctuality and discretion for your business meetings"
      }
    },
    
    // Footer
    footer: {
      description: "Premium private chauffeur service on the French Riviera. 100% electric Tesla vehicles.",
      contact: "Contact",
      hours: "Available 24/7",
      legal: "Legal Notice",
      privacy: "Privacy Policy",
      rights: "All rights reserved"
    },
    
    // Success/Error pages
    success: {
      title: "Booking Confirmed",
      message: "Thank you! Your booking has been registered.",
      whatsappMessage: "Contact us on WhatsApp for any questions",
      backHome: "Back to Home"
    },
    cancel: {
      title: "Payment Cancelled",
      message: "The payment was cancelled. You can try again.",
      retry: "Try Again"
    }
  }
};

export const getTranslation = (lang, path) => {
  const keys = path.split('.');
  let result = translations[lang] || translations.fr;
  for (const key of keys) {
    result = result?.[key];
  }
  return result || path;
};
